export default __webpack_public_path__ + "static/RTG_PDP_LOGO_EC_HTH_640x100-f388d3489639d6c288d7136f21838434.png";